export default __webpack_public_path__ + "static/media/preflop-equity-handvsrange_0024_thumb.b187d252.jpg";